import { useState } from "react";
import { Field, Honeypot, SubmitButton, SuccessBlock, useSubmit, inputCls, validEmail } from "./fields";
import { toast } from "sonner";

const INIT = { name: "", email: "", phone: "", message: "", website: "" };

export default function ServiceEnquiryForm({ serviceTitle }) {
  const [f, setF] = useState(INIT);
  const { submit, loading, success, setSuccess } = useSubmit("/contact", `Thank you. Your enquiry about ${serviceTitle} has been received. Our team will contact you shortly.`);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validEmail(f.email)) return toast.error("Please enter a valid email address.");
    const ok = await submit({
      name: f.name,
      email: f.email,
      phone: f.phone,
      message: f.message,
      subject: `Service Enquiry — ${serviceTitle}`,
      audience: "Service Page Enquiry",
      website: f.website,
    });
    if (ok) setF(INIT);
  };

  if (success)
    return <SuccessBlock testId="service-enquiry-success" message={`Thank you. Your enquiry about ${serviceTitle} has been received. Our team will contact you shortly.`} contactEmail="info@maqlinesolutions.com" onReset={() => setSuccess(false)} />;

  return (
    <form onSubmit={onSubmit} className="grid grid-cols-1 gap-4" data-testid="service-enquiry-form">
      <Honeypot value={f.website} onChange={set("website")} />
      <Field label="Name" required><input data-testid="se-name" className={inputCls + " w-full"} value={f.name} onChange={set("name")} required /></Field>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="Email" required><input data-testid="se-email" type="email" className={inputCls + " w-full"} value={f.email} onChange={set("email")} required /></Field>
        <Field label="Phone"><input data-testid="se-phone" className={inputCls + " w-full"} value={f.phone} onChange={set("phone")} /></Field>
      </div>
      <Field label={`Your question about ${serviceTitle}`} required>
        <textarea data-testid="se-message" className={inputCls + " w-full h-24 py-2.5"} value={f.message} onChange={set("message")} required placeholder="Tell us what you need — headcount, roles, location, timeline..." />
      </Field>
      <SubmitButton loading={loading} testId="service-enquiry-submit">Ask About This Service</SubmitButton>
    </form>
  );
}
